import { getContracts as o } from "../api/services/index.js";
import { restoreSearchFromCache as t, setSearch as n } from "./index2.js";
import { createKnownQueryParametersProvider as a } from "../../shared/libraries/known_query_parameters/index.js";
import { KnownQueryKey as c } from "../../shared/libraries/known_query_parameters/index3.js";
const y = async () => {
  const e = a().provideParameter(
    c.CountryCode
  );
  t(e), o(e).then((r) => {
    r.succeeded && n(e, r.result);
  });
};
export {
  y as loadAvailableContracts
};
//# sourceMappingURL=index.js.map
